import { useLocation, useNavigate } from 'react-router-dom';
import type { BuddyMatchItem } from '@wlb/shared/types/match';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { AuthFlowLayout } from '../components/layout/AuthFlowLayout';
import { Button } from '../components/ui/Button';
import { Avatar } from '../components/ui/Avatar';
import { getOnboardingMatchUsername } from '../features/auth/mapOnboardingMatch';
import { OnboardingIllustration } from '../features/auth/OnboardingIllustration';
import { MATCH_ILLUSTRATIONS } from '../features/auth/onboardingIllustrations';
import './matchOnboarding.css';

type MatchLocationState = { matches?: BuddyMatchItem[] };

export function MatchResults() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const matches = (state as MatchLocationState | null)?.matches ?? [];

  return (
    <AuthFlowLayout>
      <section className="match-onboarding match-onboarding--results">
        <button className="auth-flow__back" type="button" onClick={() => navigate('/survey/q9')} aria-label={t('matchOnboarding.backToSurvey')}>‹</button>
        <OnboardingIllustration src={MATCH_ILLUSTRATIONS.results} size="hero" />
        <h1>{t('matchOnboarding.resultsTitle')}</h1>
        <p>{t('matchOnboarding.resultsSubtitle')}</p>
        {matches.length ? (
          <ul className="match-onboarding__results" aria-label={t('matchOnboarding.matchListLabel')}>
            {matches.map((match) => {
              const username = getOnboardingMatchUsername(
                match,
                t('matchLoading.defaultMatchName'),
              );
              return (
                <li key={match.id} className="match-onboarding__result">
                  <Avatar
                    src={match.profilePictureUrl}
                    name={username}
                    seed={match.id}
                    size="lg"
                    square
                    className="match-onboarding__avatar"
                  />
                  <span><strong>{username}</strong><small>{match.tag}</small></span>
                  <b>{t('common.matchPercent', { percent: match.score })}</b>
                </li>
              );
            })}
          </ul>
        ) : <div className="match-onboarding__empty" role="status">{t('common.noMatchesFound')}</div>}
        <Button fullWidth size="lg" onClick={() => navigate('/onboarding/ai-buddy')}>{t('common.buttons.continue')}</Button>
      </section>
    </AuthFlowLayout>
  );
}
